import axios from "axios";

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? `${process.env.REACT_APP_API_BASE_URL}/api` 
    : 'https://localhost:5000/api',
  timeout : 180000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});



// INTERCEPTEUR : on ajoute le token depuis le cookie à chaque requête
api.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// INTERCEPTEUR : 401 → refresh → on relit le nouveau cookie → retry
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/refresh-token")
    ) {
      originalRequest._retry = true;

      try {
        await api.post("/auth/refresh-token");
        delete originalRequest.headers["Authorization"];

        return api(originalRequest);
      } catch (refreshError) {
        console.error("Refresh échoué → déconnexion", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;